import React from "react";
import { useLanguage } from "../../contextApi/languageContext";

const QuickNavigation = () => {

  const language = useLanguage()

  const currLanguage = language.language
  console.log("language in quick nav", currLanguage)
  const navItems = [
    {
      icon: "fa-info-circle",
      text: "Introduction",
      ar: "مقدمة",
      href: "#introduction",
    },
    {
      icon: "fa-info-circle",
      text: "Benefits",
      ar: "الفوائد",
      href: "#benefits",
    },
    {
      icon: "fa-user-check",
      text: "Eligibility",
      ar: "الأهلية",
      href: "#eligibility",
    },
    {
      icon: "fa-tasks",
      text: "Process",
      ar: "الإجراء",
      href: "#procedures",
    },
    {
      icon: "fa-clipboard-list",
      text: "Preparations",
      ar: "الاستعدادات",
      href: "#preparations",
    },
    {
      icon: "fa-chart-line",
      text: "Results",
      ar: "النتائج",
      href: "#results",
    },
    {
      icon: "fa-calendar-alt",
      text: "Book",
      ar: "الحجز",
      href: "#booking",
    },
    {
      icon: "fa-question-circle",
      text: "FAQ",
      ar: "الأسئلة الشائعة",
      href: "#faq",
    },
    {
      icon: "fa-award",
      text: "Why Us",
      ar: "لماذا نحن",
      href: "#why-us",
    },
  ];

  return (
    <div className="text-center mb-5">
      {/* Table of Contents */}
      <div className=" mx-auto" style={{ maxWidth: "800px" }}>
        <h2 className="h4 fw-bold mb-4">
          {currLanguage === "en" ? "Quick Navigation" : "تنقل سريع"}
        </h2>

        {/* Mobile grid */}
        <div className="d-lg-none row row-cols-3 g-3 text-center">
          {navItems.map((item, index) => (
            <div className="col" key={index}>
              <a
                href={item.href}
                className="text-decoration-none px-2 py-3 border rounded shadow-sm d-block h-100 text-dark hover-shadow"
              >
                <i
                  className={`fas ${item.icon} mb-2`}
                  style={{ color: "#c69933" }}
                ></i>
                <div className="small">
                  {currLanguage === "en" ? item.text : item.ar}
                </div>
              </a>
            </div>
          ))}
        </div>

        {/* Desktop nav */}
        <div className="d-none d-lg-flex flex-wrap justify-content-center gap-3 mt-3">
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.href}
              className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill text-decoration-none"
              style={{
                border: "2px solid #c69933",
                color: "#333",
                transition: "all 0.2s ease",
              }}
            >
              <i
                className={`fas ${item.icon}`}
                style={{ color: "#c69933" }}
              ></i>
              <span>{currLanguage === "en" ? item.text : item.ar}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickNavigation;
